"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainForCurrency = exports.getDomains = void 0;
const lodash_1 = require("lodash");
const types_1 = require("../types");
const graphVisibility_1 = require("./graphVisibility");
const getDomains = (indices, currency, visibilityDomain, isReducedDomain, positions) => {
    const percentStart = visibilityDomain ? visibilityDomain.x.start : 0.5;
    const percentEnd = visibilityDomain ? visibilityDomain.x.end + 1 : 1.5;
    const percentDomain = (0, lodash_1.range)(percentStart, percentEnd, 0.01);
    const res = {};
    const axisRange = visibilityDomain
        ? {
            min: Math.max(0.1, visibilityDomain.x.start),
            max: Math.max(visibilityDomain.x.end, 50000),
        }
        : (0, graphVisibility_1.getAxisRange)(indices[currency], positions);
    if (currency === types_1.Currency.BTC || currency === types_1.Currency.ETH) {
        res[currency] = (0, exports.getDomainForCurrency)(axisRange, isReducedDomain);
        return res;
    }
    for (const currency of Object.keys(types_1.Currency)) {
        if (currency === types_1.Currency.ALL || currency === types_1.Currency.USDC) {
            res[currency] = percentDomain;
        }
        else {
            res[currency] = percentDomain.map((x) => x * indices[currency]);
        }
    }
    return res;
};
exports.getDomains = getDomains;
const getDomainForCurrency = (xAxisRange, isReducedDomain) => {
    const { min, max } = xAxisRange;
    const axisRange = max - min;
    const numberOfPoints = isReducedDomain ? 150 : 5000;
    const stepUnrounded = axisRange / numberOfPoints;
    const step = findClosestGoodNumber(stepUnrounded);
    const roundedMultipleViewStart = roundToMultiple(min, step);
    const roundedMultipleViewEnd = roundToMultiple(max, step);
    const rangeXDomain = (0, lodash_1.range)(roundedMultipleViewStart, roundedMultipleViewEnd, step);
    // we cannot allow 0 since it breaks calculations with division
    rangeXDomain[0] = Math.max(0.1, rangeXDomain[0]);
    return rangeXDomain;
};
exports.getDomainForCurrency = getDomainForCurrency;
const getCurrencyXRange = (currency) => {
    switch (currency) {
        case types_1.Currency.BTC:
            return { min: 100, max: 100000 };
        case types_1.Currency.ETH:
            return { min: 10, max: 10000 };
        default:
            return { min: 1, max: 20 };
    }
};
const steps = [0.01, 0.1, 1, 5, 10, 20, 50, 100, 200, 500, 1000, 10000];
const findClosestGoodNumber = (number) => {
    return steps.find((s) => s > number) || 10;
};
const roundToMultiple = (num, step) => Math.round(num / step) * step;
